import { render, staticRenderFns } from "./FilterPageSize.vue?vue&type=template&id=34bbace8"
import script from "./FilterPageSize.vue?vue&type=script&lang=ts"
export * from "./FilterPageSize.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports